module.exports = __webpack_public_path__ + "img/mavin-logo-grey.3749c8a.svg";